export default __webpack_public_path__ + "static/media/12.83bae69f.png";